export default {"src":"/_next/static/media/suv.04e08863.svg","height":150,"width":251,"blurWidth":0,"blurHeight":0};